import { authPost } from "@api";

const EMAIL_SIGNUP = "/api/mailing-list-signup";

interface EmailSignupBody {
  email: string;
}

interface EmailSignupResponse {
  status: string;
}

export const mailingListSignup = (email: string) => {
  return authPost<EmailSignupBody, EmailSignupResponse>(EMAIL_SIGNUP, {
    email,
  });
};
